<template>
  <div class="session-tools">
    <v-btn @click='disabled = !disabled' small text>{{disabled ? 'Enable' : 'Disable'}} Tools</v-btn>
    <div v-if='!disabled' v-html='toolsHtml'></div>
  </div>
</template>

<script>
import { CubePreview } from 'cube-preview'
import Cube from 'cubejs'
const scrambleTypeNames = {
  '3x3': '333'
}

export default {
  name: 'session-tools',
  data () {
    return {
      toolsHtml: '',
      disabled: false
    }
  },
  props: {
    scramble: String
  },
  watch: {
    scramble () {
      const type = scrambleTypeNames[this.$store.state.sessionType]
      if (type === undefined) {
        this.toolsHtml = 'Cannot preview scramble for ' + this.$store.state.sessionType
        return
      }
      const getPreview = s => new CubePreview().setType(type).svgString(s)
      const cube = new Cube()
      if (!this.scramble.startsWith('No')) {
        cube.move(this.scramble)
      }
      this.toolsHtml = getPreview(cube.asString())
    }
  }
}
</script>
